import { useState } from 'react';

import { endOfDay, startOfDay } from 'date-fns';
import moment from 'moment-timezone';

import DatePicker from 'components/shared/DatePicker/DatePicker';

const FilterDateRange = ({ data, index, setFilter }) => {
  const [dateRange, setDateRange] = useState([data?.values?.startDate, data?.values?.endDate]);

  const handleChangeDate = (event) => {
    setDateRange(event);
    setFilter(index, {
      ...data,
      values: {
        startDate: startOfDay(moment(event[0]).toDate()),
        endDate: endOfDay(moment(event[1]).toDate())
      }
    });
  };

  return (
    <DatePicker
      isRange
      iconIsRight
      isClearable={false}
      value={dateRange}
      onChange={(event) => handleChangeDate(event)}
      label={data?.title || 'Date Range'}
      buttonClassName="rounded-none border-l-transparent border-t-transparent border-r-transparent"
    />
  );
};

export default FilterDateRange;
